import Vue from 'vue'
import Vuex from 'vuex'
import logger from '../logger'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    showLogin: false,
    city: 'Todas',
    reload: false,
    search: null,
    reserved: null,
    loaded: false,
    redirect: null,
    invitations: []
  },
  mutations: {
    user (state, value) { state.user = value },
    showLogin (state, value) { state.showLogin = value },
    search (state, value) { state.search = value },
    city (state, value) { state.city = value },
    reload (state, value) { state.reload = value },
    reserved (state, value) { state.reserved = value },
    redirect (state, value) { state.redirect = value },
    loaded (state, value) { state.loaded = value }
  }
})
